import { useState } from "react";
import classNames from 'classnames';

export default function InputText({ placeholder, validationLabel, value, name, onChange, label, password = false, disabled = false }) {

    const nonValidStyle = {
        backgroundColor: "#dc35454d",
        borderBottom: "1px solid #dc3545"
    }

    const disabledStyle = {
        backgroundColor: "lightgray",
        color: "gray"
    }

    const [viewInput, setViewInput] = useState(false);

    return (
        <div className="relative w-full">
            <input className={classNames("min-h-10 placeholder:text-gray outline-none border-b border-[#504343] bg-[#f5f5f5] px-2 w-full text-md focus:bg-[#ebebeb]",(password ? "pr-10" : ""))} type={password ? (viewInput ? "text" : "password") : "text"} style={disabled ? disabledStyle : (validationLabel ? nonValidStyle : {})} name={name} value={value || ""} onChange={onChange} placeholder={placeholder} disabled={disabled}/>
            <label className="absolute top-0 right-1 text-red text-xs" htmlFor={name} >{validationLabel}</label>
            <p className="text-gray text-xs">{label}</p>
            <img className={password ? "absolute top-3 right-3 h-6 opacity-50 cursor-pointer" : "hidden"} alt="view password" src="../iconslimsvet/password_view.svg" onMouseDown={() => setViewInput(true)} onMouseUp={() => setViewInput(false)} />
        </div>
    )
}